"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _i18n = _interopRequireDefault(require("../@i18n"));
var _store = require("../@api/store");
var _Icon = _interopRequireDefault(require("@custom/Icon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Message = function Message(_ref) {
  var title = _ref.title,
    description = _ref.description,
    visible = _ref.visible,
    buttons = _ref.buttons,
    hide = _ref.hide,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _onClick = _ref.onClick;
  var internalHide = function internalHide(e) {
    if (typeof hide !== 'function') {
      _store.services.message.hide();
      e.target.classList.remove('visible');
    } else {
      hide();
    }
  };
  return (0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", {
    className: "zero-floating-message ".concat(visible ? 'visible' : '', " ").concat(className),
    onClick: function onClick(e) {
      // internalHide()
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content",
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "close",
    onClick: internalHide
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faTimesCircle"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "description",
    onClick: function onClick(e) {
      e.stopPropagation();
      if (typeof _onClick === 'function') _onClick(e);
    }
  }, description), !!(buttons || []).length && /*#__PURE__*/_react["default"].createElement("div", {
    className: "buttons"
  }, (buttons || []).map(function (button, i) {
    if (button.hidden) return;
    return /*#__PURE__*/_react["default"].createElement("simple-button", button, !!button.icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: button.icon
    }), (0, _i18n["default"])(button.text));
  })))), document.body);
};
var _default = Message;
exports["default"] = _default;